export default "__VITE_ASSET__C$Qs3kmw__"